// src/components/home/HomeInfoFeed.js
// Anasayfa bilgilendirme / log alanı. Sonuçlar & Fikstür kartının hemen altında;
// duyurular, haberler, transferler, cezalar (disiplin) ve son maç sonuçlarını
// tek satırlık, tıklanabilir kayıtlar hâlinde listeler.
//
// Duyuru ve haberler SEÇİLİ İLİN haber akışından gelir (/api/news/feed?city_id):
// o ilin haberleri, tüm illere açık duyurular, o ilin takımlarının transferleri
// ve o ilin disiplin kararları. (Önceden il bilgisi olmayan eski "yazılar" ile
// tüm illerin cezaları listeleniyordu; ziyaretçi başka illerin içeriğini görüyordu.)
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { newsApi } from "../../services/newsApi";
import "./homeInfoFeed.css";

const FEED_LIMIT = 10;

// Haberler sayfasında aynı ilin akışı; editör haberi doğrudan açılır.
const newsLinkFor = (cityId, item) => {
  const params = new URLSearchParams();
  if (cityId) params.set("city", String(cityId));
  if (item?.kind === "news" && item.id) params.set("haber", String(item.id));
  return `/haberler?${params.toString()}`;
};

// Akış kaydının türünü satır rozetine çevir.
function feedKind(item) {
  if (item.kind === "transfer") return "transfer";
  if (item.kind === "penalty") return "ceza";
  return item.category === "duyuru" ? "duyuru" : "haber";
}

const KIND_LABEL = {
  duyuru: "Duyuru",
  transfer: "Transfer",
  haber: "Haber",
  ceza: "Ceza",
  sonuc: "Sonuç",
};

const timeAgo = (value) => {
  if (!value) return "";
  const d = new Date(value).getTime();
  if (!Number.isFinite(d)) return "";
  const diff = Date.now() - d;
  const min = Math.floor(diff / 60000);
  if (min < 1) return "az önce";
  if (min < 60) return `${min} dk önce`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} sa önce`;
  const day = Math.floor(hr / 24);
  if (day < 30) return `${day} gün önce`;
  return new Date(value).toLocaleDateString("tr-TR");
};

export default function HomeInfoFeed({ results = [], matchLink, cityId }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    // İl seçilmeden akış istenmez: il bilinmezken tüm illerin içeriği görünürdü.
    if (!cityId) {
      setItems([]);
      return undefined;
    }
    let alive = true;
    newsApi
      .feed({ city_id: cityId, limit: FEED_LIMIT }, { cacheTtl: 60 * 1000 })
      .then((data) => alive && setItems(Array.isArray(data?.items) ? data.items : []))
      .catch(() => alive && setItems([]));
    return () => {
      alive = false;
    };
  }, [cityId]);

  const cezalarLink = cityId ? `/sehir/${encodeURIComponent(cityId)}/cezalar` : "/cezalar";
  const rows = useMemo(() => {
    const out = [];

    (items || []).forEach((item) => {
      const kind = feedKind(item);
      out.push({
        id: `f-${item.id}`,
        kind,
        text: item.title,
        date: item.published_at || item.created_at || null,
        to: kind === "ceza" ? cezalarLink : newsLinkFor(cityId, item),
      });
    });

    (results || []).slice(0, 6).forEach((m) => {
      const hs = m.first_team_score;
      const as = m.second_team_score;
      if (hs == null || as == null) return;
      out.push({
        id: `m-${m.id}`,
        kind: "sonuc",
        text: `${m.first_team_name} ${hs}-${as} ${m.second_team_name}`,
        date: m.date || m.match_date || m.created_at || null,
        to: matchLink ? matchLink(m.id) : null,
      });
    });

    // Tarihe göre en yeni önce; tarihi olmayanlar sona.
    out.sort((a, b) => {
      const ta = a.date ? new Date(a.date).getTime() : 0;
      const tb = b.date ? new Date(b.date).getTime() : 0;
      return tb - ta;
    });
    return out.slice(0, 10);
  }, [items, results, matchLink, cezalarLink, cityId]);

  if (rows.length === 0) return null;

  return (
    <section className="hif" aria-label="Bilgilendirme akışı">
      <div className="hif__head">
        <span className="hif__eyebrow">Akış</span>
        <h2 className="hif__title">Duyurular &amp; Haberler</h2>
      </div>
      <ul className="hif__list">
        {rows.map((r) => {
          const inner = (
            <>
              <span className={`hif__badge hif__badge--${r.kind}`}>{KIND_LABEL[r.kind]}</span>
              <span className="hif__text">{r.text}</span>
              {r.date && <span className="hif__time">{timeAgo(r.date)}</span>}
              <span className="hif__chevron" aria-hidden="true">›</span>
            </>
          );
          return (
            <li key={r.id}>
              {r.to ? (
                <Link className="hif__row" to={r.to}>{inner}</Link>
              ) : (
                <div className="hif__row">{inner}</div>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
